import React, { Component } from 'react';
import{
    Container,
    Col,
    Row, 
    Button,
    Table,
    Modal,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import {ClientiTabs} from './ClientiTabs';

/**
 * Used for the Listino Prezzi section. 
 */
export class Clienti2 extends Component {

    constructor(props) {        
        super(props);

        this.toggle = this.toggle.bind(this);    
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleErrorModal = this.toggleErrorModal.bind(this);

        this.state = {    
            cliente: {
                codiceCliente: '',
                ragSoc: '',
                insegnaEsterna: '',
                piva: '',
                codFisc: '',
                sdi: '',
                email: '',
                telefono: '',
                cellulare: '',
                fax: '',
                pec: '',
                contatto: '',
                settore: '',
                note: '',
            },
            fatture: [],
            sedeLegale: {
                indirizzoId: '',
                indirizzo1: '',
                indirizzo2: '',
                localita: '',
                citta: '',
                cap: '',
                provincia: '',
                contattiNote: '',
            },
            luogoDiConsegna: [],
            pagamento: {},
            pagamenti: [],
            EConto:[],
            eliminatedLuogoDiConsegna: [],
            editting: (this.props.isNew && this.props.role === "Agenti"),
            modal: false,
            errorModal: false,
            erroreMessage: "C'era un errore. Controlla i valori e riprova.",
            modificaText: "modifica le informazioni del cliente"
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){
        if(!this.props.isNew || (this.props.isNew && sessionStorage.getItem("selectedRole") === "Amministrazione")){
            fetch(`../api/clienti/${this.props.match.params.id}`, {   
                method: 'Get',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    cliente: {
                        ...this.state.cliente,
                        codiceCliente: myjson.codiceCliente ? myjson.codiceCliente : '',
                        ragSoc: myjson.ragSoc ? myjson.ragSoc : '',
                        insegnaEsterna: myjson.insegnaEsterna ? myjson.insegnaEsterna : '',
                        piva: myjson.piva ? myjson.piva : '',
                        codFisc: myjson.codFisc ? myjson.codFisc : '',
                        sdi: myjson.sdi ? myjson.sdi : '',
                        telefono: myjson.telefono ? myjson.telefono :'',
                        cellulare: myjson.cellulare ? myjson.cellulare : '',
                        fax: myjson.fax ? myjson.fax : '',                       
                        email: myjson.email ? myjson.email : '',
                        pec: myjson.pec ? myjson.pec : '',
                        contatto: myjson.contatto ? myjson.contatto : '',
                        settore: myjson.settore ? myjson.settore : '',
                        note: myjson.note ? myjson.note : '',
                    },
                    fatture: myjson.fatture,
                    EConto : myjson.eConto,
                    sedeLegale: {
                        ...this.state.sedeLegale,
                        indirizzoId: myjson.sedeLegale.indirizzoId ? myjson.sedeLegale.indirizzoId : '',
                        indirizzo1: myjson.sedeLegale.indirizzo1 ? myjson.sedeLegale.indirizzo1 : '',
                        indirizzo2: myjson.sedeLegale.indirizzo2 ? myjson.sedeLegale.indirizzo2 : '',
                        localita: myjson.sedeLegale.localita ? myjson.sedeLegale.localita : '',
                        citta: myjson.sedeLegale.citta ? myjson.sedeLegale.citta : '',
                        cap: myjson.sedeLegale.cap ? myjson.sedeLegale.cap : '',
                        provincia: myjson.sedeLegale.provincia ? myjson.sedeLegale.provincia : '',
                        contattiNote: myjson.sedeLegale.contattiNote ? myjson.sedeLegale.contattiNote : '',
                    },
                    luogoDiConsegna: myjson.luogoDiConsegna.map(indirizzo => {
                        return {
                            ...indirizzo,
                            indirizzo1: indirizzo.indirizzo1 ? indirizzo.indirizzo1 : '',
                            indirizzo2: indirizzo.indirizzo2 ? indirizzo.indirizzo2 : '',
                            localita: indirizzo.localita ? indirizzo.localita : '',
                            citta: indirizzo.citta ? indirizzo.citta : '',
                            cap: indirizzo.cap ? indirizzo.cap : '',
                            provincia: indirizzo.provincia ? indirizzo.provincia : '',
                            contattiNote: indirizzo.contattiNote ? indirizzo.contattiNote : '',
                            nuovo: false,
                        }
                        
                    }),
                    pagamento : myjson.pagamento,
                    pagamenti : myjson.pagamenti,
                })
            }).catch(e => {
                
            });
        }
        else{
            fetch(`../api/clienti/pagamenti`, {   
                method: 'Get',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                this.setState({
                    pagamenti : myjson,
                })
            }).catch(e => {
                
            });
        }
        
    }    
    
    handleSubmit = (e) => {
        e.preventDefault();
    }

    handleClick = (index) => {

    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    toggleDropdown(){
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    getPdf = (e, id) => {
        e.preventDefault();

        fetch(`../api/clienti/fatture/${id}`, {   
            method: 'Get',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
            }),
            //Changes the response to an object
        }).then(response => response.blob())
        .then(blob => {
            window.open(URL.createObjectURL(blob))
        }).catch(e => {
            console.log(e);
        });

     }

    dropdownOnSelect = (index) => {          
        this.setState({
            luogoDiConsegnaVisible: true,
            luogoDiConsegnaSelected: index
        })
    }

    handleClienteChange = (e) => {
        this.setState({
            cliente: {
                ...this.state.cliente,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSedeLegaleChange = (e) => {
        this.setState({
            sedeLegale: {
                ...this.state.sedeLegale,
                [e.target.name]: e.target.value
            }
        })
    }

    handleLuogoDiConsegnaChange = (e, index) => {
        this.setState({
            luogoDiConsegna: this.state.luogoDiConsegna.map(
                (indirizzo, ind) => ind === index ? {...indirizzo, [e.target.name]: e.target.value } : indirizzo
            )
        })
    }

    handlePagamentoChange = (index) => {
        this.setState({
            pagamento: {
                pagamentoId: this.state.pagamenti[index].pagamentoId,
                descrizione: this.state.pagamenti[index].descrizione
            }
        })
    }

    handleLuogoDiConsegnaAddNew = (e) => {
        const withNew = this.state.luogoDiConsegna;

        withNew.push({
            indirizzo1: '',
            indirizzo2: '',
            localita: '',
            citta: '',
            cap: '',
            provincia: '',
            contattiNote: '',
            nuovo: true,
        });

        this.setState({
            luogoDiConsegna: withNew 
        });        
    }

    handleLuogoDiConsegnaDelete = (index) => {
        const eliminate = this.state.eliminatedLuogoDiConsegna;
        const list = this.state.luogoDiConsegna;

        if(list[index].nuovo){
            list.splice(index, 1)
        }
        else{
            eliminate.push(list.splice(index, 1)[0]);
        }
        
        this.setState({
            eliminatedLuogoDiConsegna: eliminate,
            luogoDiConsegna: list
        });
    }

    handleUpdateClienteInformazione = () => {
        if(this.state.editting){
            this.setState({
                editting: !this.state.editting,
                modificaText: "modifica le informazioni del cliente"
            }, () => {
                const form = {
                    cliente: this.state.cliente,
                    sedeLegale: this.state.sedeLegale,
                    luogoDiConsegna: this.state.luogoDiConsegna,
                    eliminatedLuogoDiConsegna: this.state.eliminatedLuogoDiConsegna,
                    pagamento: this.state.pagamento
                }        
        
                const headers = new Headers({
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    "Content-Type": "application/json",
                })
        
                fetch(`../api/clienti/update`,  {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(form)
                }).then(response => response.text())
                .then(response => {
                    console.log(response)
                    
                })
                .catch(error => {
                    console.log(error);
                });
            })
        }
        else{
            this.setState({
                editting: !this.state.editting,
                modificaText: "aggiornare le informazioni"
            })
        }
    }

    handleAddCliente = () => {
        if(this.state.cliente.ragSoc === ''){
            this.toggleErrorModal("Attenzione. Controlla i valori di Ragione Sociale e riprova.");
        } 
        else if(this.state.cliente.piva === '' && this.state.cliente.codFisc === ''){
            this.toggleErrorModal("Attenzione. Controlla i valori di Partita IVA o Codice Fiscale e riprova.");
        } 
        else if(this.state.sedeLegale.indirizzo1 === ''){
            this.toggleErrorModal("Attenzione. Controlla i valori di Indirrizo 1 e riprova.");
        } 
        else if(this.state.sedeLegale.localita === '' && this.state.sedeLegale.citta === ''){
            this.toggleErrorModal("Attenzione. Controlla i valori di Località o Città e riprova.");
        } 
        else if(this.state.sedeLegale.cap === ''){
            this.toggleErrorModal("Attenzione. Controlla i valori di CAP e riprova.");
        }
        else if(this.state.sedeLegale.provincia === ''){
            this.toggleErrorModal("Attenzione. Controlla i valori di Provincia e riprova.");
        }
        else{
            const form = {
                cliente: this.state.cliente,
                sedeLegale: this.state.sedeLegale,
                luogoDiConsegna: this.state.luogoDiConsegna,
                pagamento: this.state.pagamento,
            }

            if(sessionStorage.getItem("agentiId")){
                form.agentiId = sessionStorage.getItem("agentiId");
            }
    
            const headers = new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                "Content-Type": "application/json",
            })
    
            fetch(`../api/clienti/add`,  {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(form)
            }).then(response => {
                if(response.status !== 200){
                    throw response.status;
                }
                else{
                    return response.json();
                }
    
            })
            .then(response => {
                this.toggleModal();
            })
            .catch(error => {
                console.log(error);
                this.toggleErrorModal("C'era un errore. Controlla i valori e riprova.");
            });
        }
    }

    handleApproval = (approved) => {
        let form = {}

        if(approved){
            form = {
                codiceCliente: this.state.cliente.codiceCliente,
                approved: true,
                note: this.state.cliente.note,
            }
        }
        else{
            form = {
                codiceCliente: this.state.cliente.codiceCliente,
                approved: false,
                note: this.state.cliente.note,
            }
        }

        const headers = new Headers({
            'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
            "Content-Type": "application/json",
        })

        fetch(`/api/clienti/cerca/approv`,  {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(form)
        }).then(response => {
            if(response.status !== 200){
                throw response.status;
            }
            else{
                return response.json();
            }

        })
        .then(response => {
            this.toggleModal();
        })
        .catch(error => {
            console.log(error);
            this.toggleErrorModal("C'era un errore. Controlla i valori e riprova.");
        });
    }

    handleEditChange = () => {
        this.setState({
            editting: !this.state.editting,
        }, () => this.handleUpdateClienteInformazione())
    }

    toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    toggleErrorModal = (message) => {
        if(message === null){
            this.setState({
                errorModal: !this.state.errorModal
            })
        }
        else{
            this.setState({
                errorModal: !this.state.errorModal,
                erroreMessage: message,
            })
        }
        
    }

    /**
     * Renders the page
     */
    render() {
        return (
            <div>
                <Container className="d-flex align-items-start" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" xs={{size: 8}} style={{width: "100%"}}>
                            <ClientiTabs edit={false}
                                handleClienteChange={this.handleClienteChange}
                                handleSedeLegaleChange={this.handleSedeLegaleChange}
                                handleLuogoDiConsegnaChange={this.handleLuogoDiConsegnaChange}
                                handleLuogoDiConsegnaAddNew={this.handleLuogoDiConsegnaAddNew}
                                handleLuogoDiConsegnaDelete={this.handleLuogoDiConsegnaDelete}
                                handlePagamentoChange={this.handlePagamentoChange}
                                handleUpdateClienteInformazione={this.handleUpdateClienteInformazione}
                                isNew={this.props.isNew}
                                isApprove={this.props.isApprove}
                                role={this.props.role}
                                editting={this.state.editting}
                                cliente={this.state.cliente}
                                sedeLegale={this.state.sedeLegale}
                                luogoDiConsegna={this.state.luogoDiConsegna}
                                pagamento={this.state.pagamento}
                                pagamentiList={this.state.pagamenti}
                                fatture={this.state.fatture}
                                econto={this.state.EConto}
                            />     
                        </Col>
                    </Row>\
                </Container>
                {!this.props.isNew ?
                    <div>
                        <Container className="d-flex align-items-start" fluid> 
                            <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                <Col className="d-flex align-items-center justify-content-center" xs={{size: 8}} style={{width: "100%"}}>
                                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", paddingTop: "5px", paddingBottom: "5px", borderTop: "1px solid #011e41", borderBottom: "1px solid #011e41", paddingRight: "10px"}}>
                                        <Col className="d-flex align-items-center justify-content-center">
                                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.handleUpdateClienteInformazione}>
                                                {this.state.modificaText} 
                                            </Button>
                                        </Col> 
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    : 
                    <div>
                        {sessionStorage.getItem("selectedRole") === "Agenti" ?
                            <Container className="d-flex align-items-start" fluid> 
                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                    <Col className="d-flex align-items-center justify-content-center" xs={{size: 8}} style={{width: "100%"}}>
                                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", paddingTop: "5px", paddingBottom: "5px", borderTop: "1px solid #011e41", borderBottom: "1px solid #011e41", marginTop: "10px"}}>
                                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.handleAddCliente}>
                                                inserisci
                                            </Button>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container> : 
                            <div>
                                {sessionStorage.getItem("selectedRole") === "Amministrazione" ?
                                    <Container className="d-flex align-items-start" fluid> 
                                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                            <Col className="d-flex align-items-center justify-content-center" xs={{size: 8}} style={{width: "100%"}}>
                                                <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", paddingTop: "5px", paddingBottom: "5px", borderTop: "1px solid #011e41", borderBottom: "1px solid #011e41", paddingRight: "10px"}}>
                                                    <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}}>
                                                        <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.handleApproval(false)}>
                                                            disapprovi 
                                                        </Button>
                                                    </Col> 
                                                    <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}}>
                                                        <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.handleApproval(true)}>
                                                            approvi
                                                        </Button>
                                                    </Col> 
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                : null}
                            </div>
                        }
                    </div> 
                }
                <Modal onClosed={() => this.props.history.push('/')} isOpen={this.state.modal} toggle={this.toggleModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            Cliente aggiunto correttamente
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.props.history.push('/')}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.errorModal} toggle={this.toggleErrorModal} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            {this.state.erroreMessage}
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.setState({errorModal: false})}>
                                Ok
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>
            </div>  
        )
    }
}


/*<td align="left" style={{padding: "0"}}>{fattura.stato}</td>
<td align="left" style={{padding: "0"}}><a style={{padding: "0", color: "blue", cursor: "pointer"}} onClick={(e) => this.getPdf(e, fattura.fatturaId)}>{`${fattura.fatturaId}.pdf`}</a></td>*/

/*<Container className="d-flex align-items-start" fluid>
                            <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                                <Col className="d-flex align-items-center justify-content-center" xs={{size: 8}} style={{width: "100%"}}>
                                    <Row style={{width: "100%"}}>
                                        <Table responsive borderless style={{margin: "0", fontSize: "20px"}}>
                                            <thead>
                                                <tr>
                                                    <th style={{padding: "0"}}>Numero Fattura</th>
                                                    <th style={{padding: "0"}}>Data Fattura</th>
                                                    <th style={{padding: "0"}}>Importo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.fatture.map(fattura => {
                                                    return(
                                                        <tr key={fattura.fatturaId}>
                                                            <td align="left" style={{ padding: "0" }}>{fattura.fatturaId}</td>
                                                            <td align="left" style={{ padding: "0" }}>{new Date(fattura.dataFattura).toLocaleDateString()}</td>
                                                            <td align="left" style={{padding: "0"}}>{fattura.importo}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>*/


// WEBPACK FOOTER //
// ./src/components/Clienti2.js